module.exports = __webpack_public_path__ + "img/retail-red.5fd6371b.png";